import { SVGProps } from "react";

export const VerificationSuccessIllustration = (
  props: SVGProps<SVGSVGElement>
) => (
  <svg width={88} height={88} fill="none" viewBox="0 0 88 88" {...props}>
    <circle cx={44} cy={46} r={32} fill="#DEDFE0" opacity={0.2} />
    <path
      fill="#3E8D96"
      d="M10 38a2 2 0 0 1 2-2h64a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H12a2 2 0 0 1-2-2V38Z"
    />
    <mask
      id="a"
      width={12}
      height={12}
      x={14}
      y={40}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha",
      }}
    >
      <path fill="#D9D9D9" d="M14 40h12v12H14V40Z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#F7F8F8"
        d="M20 51.001a4.869 4.869 0 0 1-1.95-.393 5.049 5.049 0 0 1-1.587-1.07c-.45-.45-.806-.978-1.069-1.587a4.869 4.869 0 0 1-.394-1.95c0-.691.132-1.341.394-1.95a5.05 5.05 0 0 1 1.069-1.587c.45-.45.979-.806 1.587-1.069a4.869 4.869 0 0 1 1.95-.394 4.87 4.87 0 0 1 1.95.394 5.05 5.05 0 0 1 1.588 1.069c.45.45.806.98 1.069 1.587a4.87 4.87 0 0 1 .393 1.95c0 .692-.13 1.342-.393 1.95a5.048 5.048 0 0 1-1.07 1.588c-.45.45-.978.806-1.587 1.069A4.87 4.87 0 0 1 20 51Z"
      />
    </g>
    <rect
      width={22}
      height={3}
      x={28}
      y={42}
      fill="#F7F8F8"
      opacity={0.9}
      rx={1}
    />
    <rect
      width={46}
      height={3}
      x={28}
      y={47}
      fill="#F7F8F8"
      opacity={0.6}
      rx={1}
    />
    <path
      fill="#AACFD3"
      d="M25.043 13.143c.288-.945 1.626-.945 1.914 0l1.688 5.547a1 1 0 0 0 .665.665l5.547 1.688c.945.288.945 1.626 0 1.914l-5.547 1.688a1 1 0 0 0-.665.665l-1.688 5.547c-.288.945-1.626.945-1.914 0l-1.688-5.547a1 1 0 0 0-.665-.665l-5.547-1.688c-.945-.288-.945-1.626 0-1.914l5.547-1.688a1 1 0 0 0 .665-.665l1.688-5.547ZM61.043 65.143c.288-.945 1.626-.945 1.914 0l.755 2.48a1 1 0 0 0 .665.665l2.48.755c.945.288.945 1.626 0 1.914l-2.48.755a1 1 0 0 0-.665.665l-.755 2.48c-.288.945-1.626.945-1.914 0l-.755-2.48a1 1 0 0 0-.665-.665l-2.48-.755c-.945-.288-.945-1.626 0-1.914l2.48-.755a1 1 0 0 0 .666-.665l.754-2.48Z"
    />
    <mask
      id="b"
      width={20}
      height={20}
      x={59}
      y={11}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha",
      }}
    >
      <path fill="#D9D9D9" d="M59 11h20v20H59z" />
    </mask>
    <g mask="url(#b)">
      <circle cx={68.989} cy={21.011} r={6.833} fill="#fff" />
      <path
        fill="#1F9E80"
        d="M67.687 22.441 66 20.733a.947.947 0 0 0-.673-.256.998.998 0 0 0-.694.267.964.964 0 0 0-.277.694c0 .27.1.484.299.64l2.349 2.37c.174.2.4.3.675.3.276 0 .513-.1.712-.3l4.847-4.847a.865.865 0 0 0 .3-.662c0-.259-.1-.494-.296-.704a1.001 1.001 0 0 0-.707-.246 1 1 0 0 0-.684.267l-4.164 4.185ZM68.992 30a8.927 8.927 0 0 1-3.504-.696 8.919 8.919 0 0 1-2.873-1.919 8.927 8.927 0 0 1-1.919-2.87A8.905 8.905 0 0 1 60 21.014a8.982 8.982 0 0 1 2.62-6.375 9.063 9.063 0 0 1 2.868-1.933A8.77 8.77 0 0 1 68.985 12c1.24 0 2.41.235 3.508.704a9.049 9.049 0 0 1 2.873 1.927 9.034 9.034 0 0 1 1.93 2.87A8.833 8.833 0 0 1 78 21.013a8.765 8.765 0 0 1-.706 3.502 9.083 9.083 0 0 1-1.932 2.866 8.984 8.984 0 0 1-2.869 1.923 8.863 8.863 0 0 1-3.5.697Z"
      />
    </g>
  </svg>
);
